export default __webpack_public_path__ + "static/media/iconGeneral.ee0c1dd2.png";